import React, { Component, ErrorInfo, ReactNode } from "react";
import { Link } from "react-router-dom";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="container py-5">
          <div className="alert alert-danger" role="alert">
            <h4 className="alert-heading">Ops! Algo deu errado</h4>
            <p>
              Desculpe, encontramos um erro inesperado. Por favor, tente novamente ou
              volte para a página inicial.
            </p>
            {this.state.error && (
              <details className="mt-3">
                <summary>Detalhes técnicos</summary>
                <pre className="mt-2 small">
                  {this.state.error.message}
                  {"\n"}
                  {this.state.error.stack}
                </pre>
              </details>
            )}
            <hr />
            <div className="d-flex gap-2">
              <Link to="/" className="btn btn-primary">
                Voltar para o início
              </Link>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => window.location.reload()}
              >
                Recarregar página
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
